export const basicPopoverData = [
    {
      text: "Use the",
      code: " data-bs-toggle='popover'",
    },
    {
      text: "through popover above buttons.",
    },
  ];
  
  export const basicPopoverList = [
    {
      id: 2,
      placement: "bottom",
      popoverHeader: "Hover Popover",
      popoverBody: "Several utility instruction sets have been featured in the Bootstrap 4 to promote very easy learning for beginners in the business of web building.",
      btnColor: "success",
      btnText: "Hover tooltip",
      trigger:"hover",
    },
    {
      id: 3,
      popoverHeader: "Dismissible popover",
      popoverBody: "You are able to even develop and suggest improvements to the Bootstrap 4 before its final version is delivered.",
      btnColor: "secondary",
      btnText: "Dismissible popover",
      trigger:"focus",
    },
  ];
  
  export const directionData = [
    {
      text: "Use the",
      code: " data-bs-toggle='popover'",
    },
    {
      text: "through popover directions above buttons. ",
    },
  ];
  
  export const directionList = [
    {
      id: 5,
      placement: "right",
      popoverHeader: "Popover On Right",
      popoverBody: "Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.",
      btnColor: "danger",
      btnText: "Popover on right",
    },
    {
      id: 6,
      placement: "bottom",
      popoverHeader: "Popover On Bottom",
      popoverBody: "Identify container:to evade rendering problems in more complex components (like Bootstrap input groups, button groups, etc).",
      btnColor: "info",
      btnText: "Popover on bottom",
    },
    {
      id: 7,
      placement: "left",
      popoverHeader: "Popover On Left",
      popoverBody: "Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.",
      btnColor: "dark",
      btnText: "Popover on left",
    },
  ];
  
  export const offsetData = [
    {
      text: "Use the",
      code: ' data-bs-offset="*,*"',
    },
    {
      text: " through popover offset above buttons. ",
    },
  ];
  
  export const offsetList = [
    {
      id: 9,
      placement: "left-end",
      popoverHeader: "Popover On Left",
      popoverBody: "Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.",
      btnColor: "success",
      btnText: "Popover offset -50",
    },
  ];